/**
 * The first page of Parkour-AI eTMF, signed in or not.
 *
 * THE SCAFFOLD'S ONE PAGE. eTMF is laid down (2026-11-03) and not yet built: this page says what the product is for,
 * so the address answers with something rather than a header over white, and links to the capabilities page. It is
 * replaced by the product's real landing page when there is one.
 */
import * as React from "react";
import {Box, Typography} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import useAppContext from "../util/AppContext";

const PILLARS: [string, string][] = [
    ["Studies", "A study, its countries and its sites, each with folders on the TMF Reference Model."],
    ["Expected documents", "What each study, country and site should hold, judged against its milestones."],
    ["Controlled documents", "Draft, quality review and final, with versions, expiry dates and Part 11 signatures."],
    ["Sites", "The site's own file, documents exchanged with it, and its signed delegation and training logs."],
    ["Inspection", "Per-folder permissions, outside access with an end date, and an audit trail on every document."],
];

export default function Home() {
    const signedIn = !!useAppContext()?.sessionContext?.valid?.();
    return (
        <Box sx={{maxWidth: 960, mx: "auto", px: 3, py: 6}}>
            <Typography variant="h3" sx={{fontWeight: 500, mb: 1}}>Parkour-AI eTMF</Typography>
            <Typography variant="h6" sx={{color: "text.secondary", mb: 4}}>
                The trial master file, and the site files it exchanges documents with.
            </Typography>
            <Typography sx={{mb: 4}}>
                Study, country and site folders on the TMF Reference Model, the documents each should hold, quality
                review, expiry and the logs a site keeps, every document a controlled record inside the quality system
                the rest of the suite already runs.
            </Typography>
            <Box sx={{display: "grid", gridTemplateColumns: {xs: "1fr", sm: "1fr 1fr"}, gap: 2}}>
                {PILLARS.map(([title, text]) => (
                    <Box key={title} sx={{border: "1px solid", borderColor: "divider", borderRadius: 1, p: 2}}>
                        <Typography sx={{fontWeight: 500, mb: 0.5}}>{title}</Typography>
                        <Typography variant="body2" sx={{color: "text.secondary"}}>{text}</Typography>
                    </Box>
                ))}
            </Box>
            <Typography sx={{mt: 4}}>
                <RouterLink to="/capabilities">See every capability, and how it compares</RouterLink>
            </Typography>
            <Typography variant="body2" sx={{color: "text.secondary", mt: 2}}>
                {signedIn ? "You are signed in. eTMF is laid down and not yet built; the product starts here."
                          : "Sign in from the account icon at the top right."}
            </Typography>
        </Box>
    );
}
